import { createStructuredSelector } from 'reselect';

import LanguageLocaleUtils from 'utils/LanguageLocale';
import ShipToAccessPointEN from 'components/FrictionlessCheckout/DeliverToReleaseThree/ShipToAccessPoint/locales/ShipToAccessPoint_en_US';
import ShipToAccessPointFR from 'components/FrictionlessCheckout/DeliverToReleaseThree/ShipToAccessPoint/locales/ShipToAccessPoint_fr_CA';

const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;

const getText = getLocalisedDataFromResource(ShipToAccessPointEN, ShipToAccessPointFR);

export const shipToAccessPointModalSelector = createStructuredSelector({
    shipToAccessPointModalTitle: getTextFromResource(getText, 'shipToAccessPointModalTitle')
});
